export const iconFontAwesomePoliticalBullhorn = (
	<i className="fa-solid fa-bullhorn"></i>
);
